<template>
  <div class="page">
    <img class="policyPos" :src="hx" alt="" />
    <a @click="goAppoint()"
      ><div class="firstbutton"><img :src="hxbutton" /></div
    ></a>

    <a @click="goAppoint()"
      ><div class="secondbutton"><img :src="hxbutton" /></div
    ></a>
  </div>
</template>
<script>
import dataServer from "@/api/data";
export default {
  data() {
    return {
      hx: require("../assets/images/imgs/hx.png"),
      hxbutton: require("../assets/images/imgs/hxbutton.png"),
      mobile: "",
      platform: "HXC_APP",
      ccbParamSJ: "",
      queryParams: [],
      code: "",
      wxhost: "",
      param: "",
    };
  },
  created() {
    console.log("url:", window.location.href);
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
    }
    if (this.$route.query.param) {
      this.param = this.$route.query.param;
    }
    let loc = window.location.href;
    if (loc.indexOf("mg-uat") != -1) {
      this.wxhost = "https://tapp.creditcard.hxb.com.cn/uat/open/oauth/authorize";
    } else {
      this.wxhost = "https://app.creditcard.hxb.com.cn/open/oauth/authorize";
    }
    if (this.param) {
      this.platform = "HXB_APP";
      // 华夏银行
      this.getHXDecrypt();
    }
    // if (!this.code && !this.param) {
    //   // 华夏信用卡初次
    //   this.getHXCreditSign();
    // }
  },
  mounted() {
    // document.documentElement.style.height = "auto";
    // document.body.style.height = "auto";
  },
  methods: {
    getHXDecrypt() {
      dataServer
        .getHXDecrypt({
          ciphertext: this.param,
        })
        .then((res) => {
          if (res.status === "SUCCEED") {
            console.log(res.data);
            this.platform = "HXB_APP";
            this.mobile = res.data.mobileNo;
          }
        });
    },
    getHXCreditUserInfo() {
      dataServer
        .getHXCreditUserInfo({
          code: this.code,
        })
        .then((res) => {
          if (res.status === "SUCCEED") {
            console.log(res.data);
            this.platform = "HXC_APP";
            this.mobile = res.data.phone;
            this.$router.replace({
              path:
                "/appointDrive?colorMode=darkMode&platform=" +
                this.platform +
                "&vehicleModel=KAOLA&mobile=" +
                this.mobile,
            });
          }
        });
    },
    getHXCreditSign() {
      let hostName = window.location.hostname;
      let redirectUri =
        "https://" + hostName + "/arcfoxDigital/appointDrive?colorMode=darkMode";
      console.log("redirectUri: " + redirectUri);
      dataServer
        .getHXCreditSign({
          redirectUri: redirectUri,
        })
        .then((res) => {
          if (res.status === "SUCCEED") {
            this.queryParams = [];
            for (let key in res.data) {
              if (Object.hasOwnProperty.call(res.data, key)) {
                let element = res.data[key];
                this.queryParams.push(key + "=" + element);
              }
            }
            console.log(this.wxhost + "?" + this.queryParams.join("&"));
            window.location.href = this.wxhost + "?" + this.queryParams.join("&");
            window.open(this.wxhost + "?" + this.queryParams.join("&"));
          }
        });
    },
    getUserInfo(val) {
      dataServer.getCCBDecrypt({ ciphertext: val }).then((res) => {
        console.log(res);
        if (res.status === "SUCCEED") {
          this.mobile = res.data.mobile;
        }
      });
    },
    getUrlParams() {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == "ccbParamSJ") {
          this.ccbParamSJ = pair[1];
          console.log("ccbParamSJ:", this.ccbParamSJ);
          this.getUserInfo(this.ccbParamSJ);
        }
      }
      return;
    },
    goAppoint() {
      if (this.platform == "HXC_APP") {
        this.getHXCreditSign();
        return false;
      }
      console.log(
        "/appointDrive?colorMode=darkMode&platform=" +
          this.platform +
          "&vehicleModel=KAOLA&mobile=" +
          this.mobile
      );
      this.$router.push({
        path:
          "/appointDrive?colorMode=darkMode&platform=" +
          this.platform +
          "&vehicleModel=KAOLA&mobile=" +
          this.mobile,
      });
    },
  },
};
</script>
<style lang="scss">
.page {
  position: relative;
  padding: 0 !important;
  height: 12.9rem;
}

.darkMode .content {
  color: #7e7e7f !important;
}
.policyPos {
  width: 100%;
}

.btngo {
  position: fixed;
  display: block;
  width: 3.2rem;
  height: 0.4rem;
  bottom: 0.5rem;
  left: 50%;
  margin-left: -1.6rem;
  border-radius: 0.06rem;
  color: #fff;
  line-height: 0.4rem;
  font-size: 0.18rem;
  text-align: center;
  background-color: #4798cb !important;
  img {
    width: 100%;
  }
}
.firstbutton {
  position: absolute;
  top: 5.32rem;
  width: 1.63rem;
  height: 0.33rem;
  left: 50%;
  transform: translate(-50%, -50%);
}
.firstbutton img {
  width: 100%;
  height: 100%;
}
.secondbutton {
  position: absolute;
  bottom: 0.32rem;
  width: 1.63rem;
  height: 0.33rem;
  left: 50%;
  transform: translate(-50%, -50%);
}
.secondbutton img {
  width: 100%;
  height: 100%;
}
</style>
